import { forwardRef, useContext } from "react";
import { chain } from "react-aria";
import { useControlledState } from "@react-stately/utils";

import PhoneInputContext from "../PhoneInputContext";
import { TextInputV2, type TextInputV2Props } from "../../TextInputV2";

export type NumberProps = Omit<
  TextInputV2Props,
  | "labelProps"
  | "alerts"
  | "startSlot"
  | "type"
  | "inputMode"
  | "aria-describedby"
>;

const Number = forwardRef<HTMLInputElement, NumberProps>((props, ref) => {
  const { numberDescribedBy, startSlot } = useContext(PhoneInputContext);

  const [value, setValue] = useControlledState(
    props.value,
    props.defaultValue || ""
  );

  function handleChange(newValue: string) {
    return chain(props.onChange, setValue)(newValue.replace(/[^\d\s]/g, ""));
  }

  return (
    <TextInputV2
      aria-label="Phone number"
      {...props}
      ref={ref}
      type="tel"
      inputMode="numeric"
      startSlot={startSlot}
      value={value}
      onChange={handleChange}
      aria-describedby={numberDescribedBy}
    />
  );
});

Number.displayName = "Number";

export default Number;
